const FormTextarea = ({id, sClass, formType, type, label, name, value, handleEdit}) => {

    return (
        <div className={sClass + ' mb-4'}>
            <label className="fs-6 fw-bold mb-2">{label}</label>
            <textarea 
                type={type}
                className="form-control mb-3 mb-lg-0 rounded-0" 
                name={name} 
                value={value} 
                onChange={(e) => handleEdit(e)}
            />
        </div>
    )
};

export default FormTextarea;